export default function arraysEqualIgnoringOrder (array1, array2) {
  const set1 = new Set(array1)
  const set2 = new Set(array2)

  // Check if the sets are equal
  if (set1.size !== set2.size) {
    return false
  }

  // Compare the content of the sets
  for (const item of set1) {
    if (!set2.has(item)) {
      return false
    }
  }

  return true
}
